export default "__VITE_ASSET__CIm2BukE__"